// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f658d487b2f599b9bdca","691":"86c16c20476d900c4a0c"}[chunkId] + ".js";
};